import { visionURL } from "../../config/environment";
import JsonApiService from "../../services/jsonapiService";
import Jsona from "jsona";

const dataFormatter = new Jsona();

const courseUserAssignmentsApiService = async () =>
  new JsonApiService("course_user_assignments", {
    baseUrl: `${visionURL}/learning_center/api`,
    credentials: "include"
  });

/**
 * Retrieves the items related to a course's pending assignment
 */
export const useCourseUserAssignments = () => {
  const fetchCourseUserAssignment = async (
    courseId,
    { include = ["versions"] }
  ) => {
    const service = await courseUserAssignmentsApiService();
    const response = await service
      .include(include)
      .find(courseId)
      .then(response => response.json());

    return dataFormatter.deserialize(response);
  };

  return { fetchCourseUserAssignment };
};
